import React, { FunctionComponent } from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'ImageContainer' })(theme => ({
	root: {
		backgroundSize: 'cover',
		backgroundPosition: 'center',
		backgroundRepeat: 'no-repeat'
	}
}));

export type ImageContainerProps = {
	src: string;
	className?: string;
};

export const ImageContainer: FunctionComponent<ImageContainerProps> = (props: ImageContainerProps) => {
	let { classes: styles, cx } = useStyles();

	return (
		<div
			className={cx(styles.root, props.className)}
			style={{ backgroundImage: `url('${props.src}')` }}>
		</div>
	);
};
